module.exports = __webpack_public_path__ + "public/img/card_eye.b6f02d23.png";